import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingOtherCustomerListComponent } from './customer-billing-other-customer-list/customer-billing-other-customer-list.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { CustomerBillingOtherCustomerViewComponent } from './customer-billing-other-customer-view/customer-billing-other-customer-view.component';
import { CustomerBillingComponentsModule } from '../customer-billing-components/customer-billing-components.module';
import { CustomerBillingOtherCustomerEditComponent } from './customer-billing-other-customer-edit/customer-billing-other-customer-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { BillingComponentsModule } from '@fi-app/billing/billing-components/billing-components.module';
import { CustomerBillingOtherCustomerListStateComponent } from './customer-billing-other-customer-list/customer-billing-other-customer-list-state.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CustomerBillingResellerModule } from '@fi-app/customer-billing/customer-billing-reseller/customer-billing-reseller.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        BillingComponentsModule,
        CustomerBillingComponentsModule,
        MatRadioModule,
        FiPageHeaderModule,
        MatButtonModule,
        MatCardModule,
        CustomerBillingResellerModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
    ],
    declarations: [
        CustomerBillingOtherCustomerListComponent,
        CustomerBillingOtherCustomerViewComponent,
        CustomerBillingOtherCustomerEditComponent,
        CustomerBillingOtherCustomerListStateComponent,
    ],
})
export class CustomerBillingOtherCustomerModule {}
